export const laoHotel: Record<string, string> = {
  'JPEG, PNG or WebP · {limit} MB per image · compressed on your device':
    'JPEG, PNG ຫຼື WebP · {limit} MB ຕໍ່ຮູບ · ບີບອັດໃນອຸປະກອນຂອງທ່ານ',
  'Choose an image 10 MB or smaller.': 'ເລືອກຮູບຂະໜາດ 10 MB ຫຼື ນ້ອຍກວ່າ.',
  'Choose an image 50 MB or smaller.': 'ເລືອກຮູບຂະໜາດ 50 MB ຫຼື ນ້ອຍກວ່າ.',
  'Images must be 10 MB or smaller': 'ຮູບຕ້ອງມີຂະໜາດ 10 MB ຫຼື ນ້ອຍກວ່າ',
  'Guest documents': 'ເອກະສານແຂກ',
  'Reservation documents': 'ເອກະສານການຈອງ',
  Passport: 'ໜັງສືຜ່ານແດນ',
  'Identity document': 'ເອກະສານຢືນຢັນຕົວຕົນ',
  'Bank transfer receipt': 'ຫຼັກຖານການໂອນເງິນ',
  'Other document': 'ເອກະສານອື່ນ',
  'Document type': 'ປະເພດເອກະສານ',
  'Bank transfer reference (optional)': 'ເລກອ້າງອີງການໂອນເງິນ (ບໍ່ບັງຄັບ)',
  'Document reference (optional)': 'ເລກອ້າງອີງເອກະສານ (ບໍ່ບັງຄັບ)',
  'Upload documents': 'ອັບໂຫຼດເອກະສານ',
  'Documents uploaded': 'ອັບໂຫຼດເອກະສານແລ້ວ',
  'View document': 'ເບິ່ງເອກະສານ',
  'Open full size': 'ເປີດຂະໜາດເຕັມ',
  'Open PDF': 'ເປີດ PDF',
  'Open this PDF in a new tab or download it.': 'ເປີດ PDF ນີ້ໃນແຖບໃໝ່ ຫຼື ດາວໂຫຼດ.',
  'Remove document': 'ລຶບເອກະສານ',
  'Remove document?': 'ລຶບເອກະສານບໍ?',
  'Document removed': 'ລຶບເອກະສານແລ້ວ',
  'No documents uploaded': 'ຍັງບໍ່ມີເອກະສານທີ່ອັບໂຫຼດ',
  'Passports and identity documents stay with this guest profile across reservations.':
    'ໜັງສືຜ່ານແດນ ແລະ ເອກະສານຢືນຢັນຕົວຕົນຈະຢູ່ໃນປະຫວັດແຂກນີ້ສຳລັບທຸກການຈອງ.',
  'Attach transfer receipts and supporting documents to this reservation. Uploading a receipt does not record a payment.':
    'ແນບຫຼັກຖານການໂອນເງິນ ແລະ ເອກະສານປະກອບໃສ່ການຈອງນີ້. ການອັບໂຫຼດຫຼັກຖານບໍ່ແມ່ນການບັນທຶກຮັບເງິນ.',
  'Download this document to view its contents.': 'ດາວໂຫຼດເອກະສານນີ້ເພື່ອເບິ່ງເນື້ອໃນ.',
  'This document will be permanently removed. This cannot be undone.':
    'ເອກະສານນີ້ຈະຖືກລຶບຖາວອນ ແລະ ບໍ່ສາມາດກູ້ຄືນໄດ້.',
  'Choose one guest profile or reservation for the document.':
    'ເລືອກປະຫວັດແຂກ ຫຼື ການຈອງຢ່າງດຽວສຳລັບເອກະສານ.',
  'Save identity documents on the guest profile and transfer receipts on the reservation.':
    'ບັນທຶກເອກະສານຢືນຢັນຕົວຕົນໃນປະຫວັດແຂກ ແລະ ຫຼັກຖານໂອນເງິນໃນການຈອງ.',
  'The file contents do not match its type. Choose another file.':
    'ເນື້ອໃນໄຟລ໌ບໍ່ກົງກັບປະເພດໄຟລ໌. ເລືອກໄຟລ໌ອື່ນ.',
  'Check out with balance due': 'ເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງຊຳລະ',
  'Checked out · balance due': 'ເຊັກເອົ້າແລ້ວ · ຍັງຄ້າງຊຳລະ',
  'Guest checked out · balance due': 'ແຂກເຊັກເອົ້າແລ້ວ · ຍັງຄ້າງຊຳລະ',
  'Reason and payment arrangements': 'ເຫດຜົນ ແລະ ການນັດໝາຍຊຳລະ',
  'Balance due at checkout': 'ຍອດຄ້າງຊຳລະຕອນເຊັກເອົ້າ',
  'Release the room and keep the unpaid balance on the guest folio for later collection. Booked nights and charges are retained. No payment is recorded.':
    'ປົດຫ້ອງ ແລະ ເກັບຍອດຄ້າງຊຳລະໄວ້ໃນບັນຊີແຂກເພື່ອເກັບເງິນພາຍຫຼັງ. ຄ່າຄືນພັກທີ່ຈອງ ແລະ ຄ່າໃຊ້ຈ່າຍຍັງຄົງເດີມ. ບໍ່ມີການບັນທຶກຮັບເງິນ.',
  'Invoice all charges and post every invoice before checkout with a balance.':
    'ອອກໃບແຈ້ງໜີ້ສຳລັບຄ່າໃຊ້ຈ່າຍທັງໝົດ ແລະ ລົງບັນຊີທຸກໃບກ່ອນເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງ.',
  'Guest has checked out. The unpaid balance remains due; record payment when it is received.':
    'ແຂກເຊັກເອົ້າແລ້ວ. ຍອດຄ້າງຍັງຕ້ອງຊຳລະ; ບັນທຶກຮັບເງິນເມື່ອໄດ້ຮັບແລ້ວ.',
  'Settle the balance, check out with balance due, or use direct bill checkout for a company account.':
    'ຊຳລະຍອດຄ້າງ, ເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງ ຫຼື ເຊັກເອົ້າແບບອອກໃບແຈ້ງໜີ້ໃຫ້ບັນຊີບໍລິສັດ.',
  'Settle the balance, or choose checkout with balance due and record payment arrangements.':
    'ຊຳລະຍອດຄ້າງ ຫຼື ເລືອກເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງ ແລະ ບັນທຶກການນັດໝາຍຊຳລະ.',
  'Checkout with a balance applies to checkout only':
    'ການຍອມໃຫ້ຍັງມີຍອດຄ້າງໃຊ້ໄດ້ສຳລັບເຊັກເອົ້າເທົ່ານັ້ນ',
  'Enter the reason and payment arrangements for checkout with a balance':
    'ລະບຸເຫດຜົນ ແລະ ການນັດໝາຍຊຳລະສຳລັບເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງ',
  'Choose guest balance or direct billing, not both':
    'ເລືອກຍອດຄ້າງຂອງແຂກ ຫຼື ອອກໃບແຈ້ງໜີ້ໃຫ້ບໍລິສັດຢ່າງໃດຢ່າງໜຶ່ງ',
  'Post every invoice before checkout with a balance':
    'ລົງບັນຊີທຸກໃບແຈ້ງໜີ້ກ່ອນເຊັກເອົ້າໂດຍຍັງມີຍອດຄ້າງ',
  'Booking notes': 'ບັນທຶກການຈອງ',
  'Incoming bookings': 'ການຈອງທີ່ລໍຖ້າເຂົ້າພັກ',
  Incoming: 'ລໍຖ້າເຂົ້າພັກ',
  'New bookings': 'ການຈອງໃໝ່',
  'All booking notes, ranked by stay urgency. Includes past bookings.':
    'ບັນທຶກການຈອງທັງໝົດ ຈັດຕາມຄວາມຮີບດ່ວນ ລວມທັງການຈອງທີ່ຜ່ານມາ.',
  'All expected arrivals. New bookings were created in the last 7 days.':
    'ແຂກທັງໝົດທີ່ລໍຖ້າເຂົ້າພັກ. ການຈອງໃໝ່ແມ່ນການຈອງທີ່ສ້າງໃນ 7 ວັນຜ່ານມາ.',
  'Search notes, guests or rooms': 'ຄົ້ນຫາບັນທຶກ, ແຂກ ຫຼື ຫ້ອງ',
  'Search guests, bookings or rooms': 'ຄົ້ນຫາແຂກ, ການຈອງ ຫຼື ຫ້ອງ',
  'Stay urgency · nearest arrival first': 'ຄວາມຮີບດ່ວນ · ວັນເຂົ້າພັກທີ່ໃກ້ທີ່ສຸດກ່ອນ',
  'Booking view': 'ມຸມມອງການຈອງ',
  'Needs attention': 'ຕ້ອງກວດສອບ',
  'Arriving today': 'ເຂົ້າພັກມື້ນີ້',
  'In-house guest': 'ແຂກທີ່ກຳລັງພັກ',
  'Upcoming stay': 'ການເຂົ້າພັກທີ່ຈະມາເຖິງ',
  'Past / closed booking': 'ການຈອງທີ່ຜ່ານມາ / ປິດແລ້ວ',
  'No matching bookings': 'ບໍ່ພົບການຈອງທີ່ກົງກັນ',
  'No booking notes yet': 'ຍັງບໍ່ມີບັນທຶກການຈອງ',
  'No new bookings in the last 7 days': 'ບໍ່ມີການຈອງໃໝ່ໃນ 7 ວັນຜ່ານມາ',
  'No incoming bookings': 'ບໍ່ມີການຈອງທີ່ລໍຖ້າເຂົ້າພັກ',
  'Try another guest, booking number or room.': 'ລອງຄົ້ນຫາແຂກ, ເລກການຈອງ ຫຼື ຫ້ອງອື່ນ.',
  'Add guest notes from a reservation. They will appear here.':
    'ເພີ່ມບັນທຶກແຂກໃນການຈອງ ແລ້ວຈະສະແດງຢູ່ທີ່ນີ້.',
  'Bookings will appear here when they are created.': 'ການຈອງຈະສະແດງຢູ່ທີ່ນີ້ເມື່ອຖືກສ້າງ.',
  Rank: 'ລຳດັບ',
  'Read full note': 'ອ່ານບັນທຶກທັງໝົດ',
  'Collapse note': 'ຫຍໍ້ບັນທຶກ',

  'Guests in the primary room. Set additional room counts below.':
    'ແຂກໃນຫ້ອງຫຼັກ. ກຳນົດຈຳນວນແຂກໃນຫ້ອງເພີ່ມຂ້າງລຸ່ມ.',
  'Review additional rooms: availability or guest capacity has changed.':
    'ກວດຫ້ອງເພີ່ມ: ຫ້ອງຫວ່າງ ຫຼື ຄວາມຈຸແຂກປ່ຽນແປງແລ້ວ.',
  'Blocked period': 'ຊ່ວງວັນທີທີ່ກັນໄວ້',
  'Block starts': 'ເລີ່ມກັນຫ້ອງ',
  'Block ends': 'ສິ້ນສຸດການກັນຫ້ອງ',
  'The end date is not blocked.': 'ບໍ່ລວມວັນສິ້ນສຸດໃນການກັນຫ້ອງ.',
  'Original reason': 'ເຫດຜົນເດີມ',
  Released: 'ປົດແລ້ວ',
  'This block has already been cleared.': 'ການກັນຫ້ອງນີ້ຖືກປົດແລ້ວ.',
  'Ask a manager to clear this block.': 'ຕິດຕໍ່ຜູ້ຈັດການເພື່ອປົດການກັນຫ້ອງນີ້.',
  'Clear this block': 'ປົດການກັນຫ້ອງນີ້',
  'This clears the full date range, including dates outside the current calendar view.':
    'ການປົດນີ້ມີຜົນຕໍ່ຊ່ວງວັນທີທັງໝົດ ລວມທັງວັນທີທີ່ຢູ່ນອກໜ້າປະຕິທິນປັດຈຸບັນ.',
  'This note is kept in the activity history.': 'ບັນທຶກນີ້ຈະເກັບໄວ້ໃນປະຫວັດກິດຈະກຳ.',
  'Why is this block being cleared?': 'ເພາະເຫດໃດຈຶ່ງປົດການກັນຫ້ອງນີ້?',
  'Dates are available again': 'ວັນທີນີ້ສາມາດຈອງໄດ້ອີກຄັ້ງ',
  'Plans changed': 'ແຜນການປ່ຽນແປງ',
  'Block created by mistake': 'ສ້າງການກັນຫ້ອງຜິດພາດ',
  'Guest no longer needs the hold': 'ແຂກບໍ່ຕ້ອງການກັນຫ້ອງແລ້ວ',
  'Hold expired': 'ໝົດເວລາກັນຫ້ອງແລ້ວ',
  'Repairs completed': 'ສ້ອມແປງສຳເລັດແລ້ວ',
  'Maintenance no longer needed': 'ບໍ່ຈຳເປັນຕ້ອງບຳລຸງຮັກສາແລ້ວ',
  'Allocation no longer needed': 'ບໍ່ຈຳເປັນຕ້ອງຈັດສັນຫ້ອງແລ້ວ',
  'Group plans changed': 'ແຜນຂອງກຸ່ມປ່ຽນແປງ',
  'Other reason': 'ເຫດຜົນອື່ນ',
  'Describe the reason': 'ລະບຸເຫດຜົນ',
  'Clear dates': 'ປົດການກັນວັນທີ',
  'Restore room · Needs cleaning': 'ເປີດຫ້ອງຄືນ · ຕ້ອງທຳຄວາມສະອາດ',
  'Change room status': 'ປ່ຽນສະຖານະຫ້ອງ',
  'Mark done · Ready': 'ສຳເລັດ · ພ້ອມໃຊ້ງານ',
  'Ended blocks can be viewed but cannot be cleared.':
    'ສາມາດເບິ່ງການກັນຫ້ອງທີ່ສິ້ນສຸດແລ້ວ ແຕ່ບໍ່ສາມາດປົດໄດ້.',
  'Clear dates removes this entire block, including dates outside the current calendar view.':
    'ການປົດວັນທີຈະປົດການກັນຫ້ອງທັງໝົດ ລວມທັງວັນທີທີ່ຢູ່ນອກໜ້າປະຕິທິນປັດຈຸບັນ.',
  'This room is also marked out of service. Restore its room status separately to reopen availability.':
    'ຫ້ອງນີ້ຍັງຖືກໝາຍວ່າປິດໃຊ້ງານ. ປ່ຽນສະຖານະຫ້ອງແຍກຕ່າງຫາກເພື່ອເປີດການຈອງຄືນ.',
  'Room blocks prevent bookings and do not create guest charges. Open a block on the calendar to clear its dates.':
    'ການກັນຫ້ອງປ້ອງກັນການຈອງ ແລະ ບໍ່ສ້າງຄ່າໃຊ້ຈ່າຍແຂກ. ເປີດການກັນຫ້ອງໃນປະຕິທິນເພື່ອປົດວັນທີ.',

  'Split room accommodation': 'ການພັກແບ່ງຫຼາຍຫ້ອງຕາມວັນທີ',
  Group: 'ກຸ່ມ',
  'Multi-room reservation': 'ການຈອງຫຼາຍຫ້ອງ',
  'Multi-room reservation created': 'ສ້າງການຈອງຫຼາຍຫ້ອງແລ້ວ',
  'Room lock': 'ລັອກການຈັດຫ້ອງ',
  'Lock room assignment': 'ລັອກການຈັດຫ້ອງ',
  'Unlock room assignment': 'ປົດລັອກການຈັດຫ້ອງ',
  'Room assignment locked': 'ລັອກການຈັດຫ້ອງແລ້ວ',
  'Room assignment unlocked': 'ປົດລັອກການຈັດຫ້ອງແລ້ວ',
  'Unlock the room assignment before moving this reservation': 'ປົດລັອກການຈັດຫ້ອງກ່ອນຍ້າຍການຈອງນີ້',
  'Additional rooms': 'ຫ້ອງເພີ່ມເຕີມ',
  'Selected rooms are saved together as one multi-room booking. Each room keeps its own stay and folio.':
    'ຫ້ອງທີ່ເລືອກຈະບັນທຶກເປັນການຈອງຫຼາຍຫ້ອງດຽວກັນ ໂດຍແຕ່ລະຫ້ອງມີການພັກ ແລະ ໂຟລິໂອຂອງຕົນເອງ',
  'Base rate per room': 'ລາຄາພື້ນຖານຕໍ່ຫ້ອງ',
  'Choose a date range of up to 366 nights.': 'ເລືອກຊ່ວງວັນທີບໍ່ເກີນ 366 ຄືນ.',
  'Choose an available room to continue.': 'ເລືອກຫ້ອງຫວ່າງເພື່ອດຳເນີນການຕໍ່.',
  'Room blocks prevent bookings and do not create guest charges. Release them from Service & maintenance.':
    'ການກັນຫ້ອງປ້ອງກັນການຈອງ ແລະ ບໍ່ສ້າງຄ່າໃຊ້ຈ່າຍແຂກ. ປົດການກັນຫ້ອງໄດ້ຈາກໜ້າບໍລິການ ແລະ ບຳລຸງຮັກສາ.',
  'No rooms available for these dates. Try different dates.':
    'ບໍ່ມີຫ້ອງຫວ່າງໃນຊ່ວງວັນທີນີ້. ກະລຸນາເລືອກວັນທີອື່ນ.',
  'The end date is exclusive. The room becomes bookable on this date.':
    'ບໍ່ລວມວັນສິ້ນສຸດ. ຫ້ອງຈະສາມາດຈອງໄດ້ໃນວັນນີ້.',
  'Identify the group or event. Create guest reservations separately after releasing the allocation.':
    'ລະບຸກຸ່ມ ຫຼື ກິດຈະກຳ. ສ້າງການຈອງແຂກແຍກຕ່າງຫາກຫຼັງປົດການກັນຫ້ອງ.',
  'Group / event & allocation reason': 'ກຸ່ມ / ກິດຈະກຳ ແລະ ເຫດຜົນການຈັດສັນ',
  'Set aside a room for a group, event, or accommodation allocation.':
    'ກັນຫ້ອງໄວ້ສຳລັບກຸ່ມແຂກ ງານກິດຈະກຳ ຫຼື ການຈັດສັນທີ່ພັກ.',
  'Save accommodation block': 'ບັນທຶກການກັນຫ້ອງພັກ',
  'New accommodation block': 'ເພີ່ມການກັນຫ້ອງພັກ',
  'Describe the issue or work required. Room readiness is managed separately.':
    'ລະບຸບັນຫາ ຫຼື ວຽກທີ່ຕ້ອງເຮັດ. ສະຖານະຄວາມພ້ອມຂອງຫ້ອງຈັດການແຍກຕ່າງຫາກ.',
  'Maintenance reason': 'ເຫດຜົນການບຳລຸງຮັກສາ',
  'Remove a room from available inventory for repairs or maintenance during these dates.':
    'ງົດການຈອງຫ້ອງເພື່ອສ້ອມແປງ ຫຼື ບຳລຸງຮັກສາໃນຊ່ວງວັນທີນີ້.',
  'Save out-of-service period': 'ບັນທຶກຊ່ວງງົດໃຫ້ບໍລິການ',
  'Mark out of service': 'ກຳນົດຫ້ອງງົດໃຫ້ບໍລິການ',
  'Include who requested the hold and when staff should follow up. Holds do not expire automatically.':
    'ລະບຸຜູ້ຂໍກັນຫ້ອງ ແລະ ເວລາທີ່ພະນັກງານຄວນຕິດຕາມ. ການກັນຫ້ອງບໍ່ໝົດອາຍຸອັດຕະໂນມັດ.',
  'Guest / contact & hold reason': 'ແຂກ / ຜູ້ຕິດຕໍ່ ແລະ ເຫດຜົນການກັນຫ້ອງ',
  'Hold a room temporarily while a guest decides. Release the hold when it is no longer needed.':
    'ກັນຫ້ອງຊົ່ວຄາວລະຫວ່າງລໍຖ້າແຂກຕັດສິນໃຈ. ປົດການກັນຫ້ອງເມື່ອບໍ່ຈຳເປັນແລ້ວ.',
  'Save courtesy hold': 'ບັນທຶກການກັນຫ້ອງຊົ່ວຄາວ',
  'New courtesy hold': 'ກັນຫ້ອງຊົ່ວຄາວ',
  'Explain why these dates are unavailable.': 'ລະບຸເຫດຜົນທີ່ຫ້ອງບໍ່ຫວ່າງໃນຊ່ວງວັນທີນີ້.',
  'Prevent bookings for a specific room and date range.':
    'ປ້ອງກັນການຈອງຫ້ອງທີ່ເລືອກໃນຊ່ວງວັນທີທີ່ກຳນົດ.',
  'Save blocked dates': 'ບັນທຶກວັນທີກັນຫ້ອງ',
  'Block dates': 'ກັນຫ້ອງຕາມວັນທີ',
  'An inquiry holds this room until it is confirmed or canceled. Confirm it before check-in.':
    'ການສອບຖາມຈະກັນຫ້ອງນີ້ໄວ້ຈົນກວ່າຈະຢືນຢັນ ຫຼື ຍົກເລີກ. ຕ້ອງຢືນຢັນກ່ອນເຊັກອິນ.',
  'Inquiry created': 'ບັນທຶກການສອບຖາມແລ້ວ',
  'Create inquiry': 'ບັນທຶກການສອບຖາມ',
  'New inquiry': 'ເພີ່ມການສອບຖາມ',
  'Choose the type, room, and dates to mark your calendar.':
    'ເລືອກປະເພດ ຫ້ອງ ແລະ ວັນທີເພື່ອບັນທຶກໃນປະຕິທິນ.',
  'New calendar entry': 'ເພີ່ມລາຍການໃນປະຕິທິນ',
  'Calendar entry type': 'ປະເພດລາຍການໃນປະຕິທິນ',
  'Confirmation Pending': 'ລໍຖ້າຢືນຢັນ',
  'In-House': 'ກຳລັງພັກ',
  'Checked Out': 'ເຊັກເອົາແລ້ວ',
  'No Show': 'ບໍ່ມາເຂົ້າພັກ',
  Canceled: 'ຍົກເລີກແລ້ວ',
  Inquiry: 'ສອບຖາມການຈອງ',
  'Courtesy Hold': 'ກັນຫ້ອງຊົ່ວຄາວ',
  'Blocked Dates': 'ປິດຫ້ອງຕາມວັນທີ',
  'Accommodation Blocks': 'ກັນຫ້ອງພັກ',
  'Calendar blocks': 'ການກັນຫ້ອງໃນປະຕິທິນ',
  'Block type': 'ປະເພດການກັນຫ້ອງ',
  'Confirm reservation': 'ຢືນຢັນການຈອງ',
  'Reservation confirmed': 'ຢືນຢັນການຈອງແລ້ວ',
  'Pending reservations must be confirmed before check-in.': 'ຕ້ອງຢືນຢັນການຈອງທີ່ລໍຖ້າກ່ອນເຊັກອິນ.',
  'Active reservations holding room inventory.': 'ການຈອງທີ່ຍັງໃຊ້ງານ ແລະ ກັນຫ້ອງພັກ.',
  'Rooms & availability': 'ຫ້ອງ ແລະ ຄວາມຫວ່າງ',
  'Expand all': 'ຂະຫຍາຍທັງໝົດ',
  'Collapse all': 'ຍໍ້ທັງໝົດ',
  'Available rooms': 'ຫ້ອງຫວ່າງ',
  available: 'ຫວ່າງ',
  'All room statuses': 'ທຸກສະຖານະຫ້ອງ',
  'Compact view': 'ມຸມມອງກະທັດຮັດ',
  Fullscreen: 'ເຕັມຈໍ',
  'Exit fullscreen': 'ອອກຈາກເຕັມຈໍ',
  'Expand calendar to fullscreen': 'ຂະຫຍາຍປະຕິທິນໃຫ້ເຕັມຈໍ',
  'Exit calendar fullscreen': 'ອອກຈາກປະຕິທິນເຕັມຈໍ',
  'Overdue departure': 'ເລີຍກຳນົດອອກ',
  Overstay: 'ພັກເກີນກຳນົດ',
  'Room not vacated': 'ຫ້ອງຍັງບໍ່ວ່າງ',
  'Guests past checkout': 'ແຂກເລີຍກຳນົດອອກ',
  'guest past checkout': 'ແຂກເລີຍກຳນົດອອກ',
  'guests past checkout': 'ແຂກເລີຍກຳນົດອອກ',
  'arrival waiting for a room': 'ການຈອງທີ່ລໍຖ້າຫ້ອງ',
  'arrivals waiting for a room': 'ການຈອງທີ່ລໍຖ້າຫ້ອງ',
  'Check out each guest, or extend the stay so the extra nights are charged.':
    'ເຊັກເອົາແຂກ ຫຼື ຂະຫຍາຍການພັກເພື່ອຄິດຄ່າຄືນທີ່ພັກເພີ່ມ',
  Move: 'ຍ້າຍ',
  'Checkout was due on': 'ກຳນົດອອກແມ່ນວັນທີ',
  'The guest is still in the room without a booked night. Check out now, or extend the stay so the extra nights are charged.':
    'ແຂກຍັງຢູ່ໃນຫ້ອງໂດຍບໍ່ມີຄືນທີ່ຈອງໄວ້. ເຊັກເອົາດຽວນີ້ ຫຼື ຂະຫຍາຍການພັກເພື່ອຄິດຄ່າຄືນທີ່ພັກເພີ່ມ',
  'Reservation details': 'ລາຍລະອຽດການຈອງ',
  'Close reservation details': 'ປິດລາຍລະອຽດການຈອງ',
  'Back to calendar': 'ກັບໄປປະຕິທິນ',
  'No guest notes recorded.': 'ຍັງບໍ່ມີບັນທຶກກ່ຽວກັບແຂກ',
  'Edit guest notes': 'ແກ້ໄຂບັນທຶກແຂກ',
  'Departure due. The room stays occupied until checkout is recorded.':
    'ຄົບກຳນົດອອກແລ້ວ. ຫ້ອງຍັງມີແຂກພັກຈົນກວ່າຈະບັນທຶກການອອກ',
  'Hotel settings': 'ຕັ້ງຄ່າໂຮງແຮມ',
  'Rooms, arrivals and departures for your shift.': 'ຫ້ອງ ການເຂົ້າພັກ ແລະ ການອອກ ສຳລັບກະຂອງທ່ານ',
  'Calendar length': 'ຈຳນວນວັນໃນປະຕິທິນ',
  'Previous period': 'ຊ່ວງກ່ອນ',
  'Next period': 'ຊ່ວງຖັດໄປ',
  days: 'ວັນ',
  'Clear filters': 'ລ້າງຕົວກອງ',
  Filters: 'ຕົວກອງ',
  'Active filters': 'ຕົວກອງທີ່ໃຊ້ຢູ່',
  'Remove filter': 'ລຶບຕົວກອງ',
  of: 'ຈາກ',
  'Reservation pages': 'ໜ້າລາຍການຈອງ',
  'Previous page': 'ໜ້າກ່ອນ',
  'Next page': 'ໜ້າຕໍ່ໄປ',
  Yesterday: 'ມື້ວານ',
  'Rooms ready': 'ຫ້ອງພ້ອມ',
  'Housekeeping readiness': 'ຄວາມພ້ອມຂອງແມ່ບ້ານ',
  'Find a room or guest': 'ຄົ້ນຫາຫ້ອງ ຫຼື ແຂກ',
  'Scroll the calendar to see more dates.': 'ເລື່ອນປະຕິທິນເພື່ອເບິ່ງວັນອື່ນ',
  'No rooms match these filters': 'ບໍ່ມີຫ້ອງທີ່ກົງກັບຕົວກອງ',
  'Reservation view': 'ມຸມມອງການຈອງ',
  'Needs payment': 'ຕ້ອງຊຳລະເງິນ',
  'Sort reservations': 'ຈັດລຽງການຈອງ',
  'Arrival date': 'ວັນເຂົ້າພັກ',
  'Departure date': 'ວັນອອກ',
  'Per page': 'ຕໍ່ໜ້າ',
  'Export includes the full date window.': 'ການສົ່ງອອກລວມທັງຊ່ວງວັນທີ່ເລືອກ',
  'Room readiness': 'ຄວາມພ້ອມຂອງຫ້ອງ',
  'All rooms': 'ທຸກຫ້ອງ',
  'All floors': 'ທຸກຊັ້ນ',
  'Task priority': 'ຄວາມສຳຄັນຂອງວຽກ',
  'All priorities': 'ທຸກລະດັບຄວາມສຳຄັນ',
  'tasks in this view': 'ວຽກໃນມຸມມອງນີ້',
  'Urgent tasks first': 'ວຽກດ່ວນກ່ອນ',
  'Active plans only': 'ສະເພາະແຜນທີ່ເປີດໃຊ້',
  'No rate plans match these filters': 'ບໍ່ມີແຜນລາຄາທີ່ກົງກັບຕົວກອງ',
  'VIP guests only': 'ສະເພາະແຂກ VIP',
  'profiles in this view': 'ປະຫວັດແຂກໃນມຸມມອງນີ້',
  'Try another name or clear your filters.': 'ລອງຊື່ອື່ນ ຫຼື ລ້າງຕົວກອງ',
  'No contact details recorded': 'ຍັງບໍ່ມີຂໍ້ມູນຕິດຕໍ່',
  'stays need attention': 'ການພັກທີ່ຕ້ອງກວດສອບ',
  'Availability could not be checked. Try again.': 'ບໍ່ສາມາດກວດຫ້ອງວ່າງໄດ້ ກະລຸນາລອງໃໝ່',
  'Choose a departure after arrival.': 'ເລືອກວັນອອກຫຼັງວັນເຂົ້າພັກ',
  'No rooms available for these dates and guest count. Try different dates or fewer guests.':
    'ບໍ່ມີຫ້ອງວ່າງຕາມວັນ ແລະ ຈຳນວນແຂກນີ້ ລອງປ່ຽນວັນ ຫຼື ຫຼຸດຈຳນວນແຂກ',
  'available rooms for this stay': 'ຫ້ອງວ່າງສຳລັບການພັກນີ້',
  guest: 'ແຂກ',
  'Undo check-in': 'ຍົກເລີກການເຂົ້າພັກ',
  'Undo check-in reason': 'ເຫດຜົນທີ່ຍົກເລີກການເຂົ້າພັກ',
  'Check-in undone': 'ຍົກເລີກການເຂົ້າພັກແລ້ວ',
  'Early check out': 'ອອກກ່ອນກຳນົດ',
  'Early checkout reason': 'ເຫດຜົນທີ່ອອກກ່ອນກຳນົດ',
  'Confirm early checkout': 'ຢືນຢັນການອອກກ່ອນກຳນົດ',
  'Guest checked out early': 'ແຂກອອກກ່ອນກຳນົດແລ້ວ',
  'Deposit amount (LAK)': 'ຈຳນວນເງິນມັດຈຳ (ກີບ)',
  'Deposit amount': 'ຈຳນວນເງິນມັດຈຳ',
  'Enter a deposit amount': 'ປ້ອນຈຳນວນເງິນມັດຈຳ',
  'Amount is only available when recording a deposit': 'ປ້ອນຈຳນວນໄດ້ສະເພາະຕອນບັນທຶກມັດຈຳ',
  'Enter a reason for this action': 'ປ້ອນເຫດຜົນສຳລັບການດຳເນີນການນີ້',
  'Recorded deposit': 'ເງິນມັດຈຳທີ່ບັນທຶກ',
  'Amount not recorded': 'ຍັງບໍ່ໄດ້ບັນທຶກຈຳນວນ',
  'Note (optional)': 'ໝາຍເຫດ (ຖ້າມີ)',
  'Receipt required to update balance': 'ຕ້ອງມີໃບຮັບເງິນເພື່ອປັບຍອດຄ້າງ',
  'Actual departure': 'ວັນອອກຕົວຈິງ',
  'Booked departure': 'ວັນອອກທີ່ຈອງໄວ້',
  'Actual checkout': 'ການອອກຕົວຈິງ',
  'Released before use': 'ປ່ອຍຫ້ອງກ່ອນເຂົ້າພັກ',
  'Review stay charges': 'ກວດສອບຄ່າພັກ',
  'Check out today and release the room. Booked nights and charges are retained.':
    'ອອກມື້ນີ້ ແລະ ເປີດຫ້ອງໃຫ້ຈອງໄດ້ ຈຳນວນຄືນ ແລະ ຄ່າພັກທີ່ຈອງໄວ້ຍັງຄົງເດີມ',
  'Return this stay to Confirmed. Keep the folio, deposit and full activity history.':
    'ຄືນການພັກນີ້ເປັນຢືນຢັນແລ້ວ ຮັກສາບັນຊີຄ່າພັກ ເງິນມັດຈຳ ແລະ ປະຫວັດທັງໝົດ',
  'Available on the arrival date before an occupied room move. Room readiness is unchanged.':
    'ໃຊ້ໄດ້ໃນວັນເຂົ້າພັກ ກ່ອນຍ້າຍຫ້ອງທີ່ເຂົ້າພັກແລ້ວ ສະຖານະຄວາມພ້ອມຂອງຫ້ອງຄົງເດີມ',
  'Only an in-house guest can undo check-in': 'ຍົກເລີກການເຂົ້າພັກໄດ້ສະເພາະແຂກທີ່ກຳລັງພັກ',
  'Undo check-in is available on the arrival date only': 'ຍົກເລີກການເຂົ້າພັກໄດ້ສະເພາະວັນເຂົ້າພັກ',
  'Check-in cannot be undone after an occupied room move':
    'ບໍ່ສາມາດຍົກເລີກການເຂົ້າພັກຫຼັງຍ້າຍຫ້ອງທີ່ເຂົ້າພັກແລ້ວ',
  'Use regular checkout on or after the departure date': 'ໃຊ້ການອອກປົກກະຕິໃນວັນອອກ ຫຼື ຫຼັງຈາກນັ້ນ',
  'Use early check out to review a departure before the booked date.':
    'ໃຊ້ການອອກກ່ອນກຳນົດເພື່ອກວດສອບການອອກກ່ອນວັນທີ່ຈອງໄວ້',
  'Activity history': 'ປະຫວັດການດຳເນີນການ',
  'Newest first': 'ໃໝ່ສຸດກ່ອນ',
  'Show earlier activity': 'ສະແດງປະຫວັດກ່ອນໜ້າ',
  'No activity recorded yet.': 'ຍັງບໍ່ມີປະຫວັດທີ່ບັນທຶກ',
  'Reservation updated': 'ປັບປຸງການຈອງແລ້ວ',
  'Deposit recorded': 'ບັນທຶກເງິນມັດຈຳແລ້ວ',
  'Guest group changed': 'ປ່ຽນກຸ່ມແຂກແລ້ວ',
  'Removed from guest group': 'ເອົາອອກຈາກກຸ່ມແຂກແລ້ວ',
  'Stay dates': 'ວັນເຂົ້າ ແລະ ວັນອອກ',
  'Retained folio total': 'ຍອດຄ່າພັກທີ່ຮັກສາໄວ້',
  Removed: 'ເອົາອອກແລ້ວ',
  'Unknown user': 'ບໍ່ຮູ້ຊື່ຜູ້ໃຊ້',
  'No-show': 'ບໍ່ມາເຂົ້າພັກ',
  Deposited: 'ຈ່າຍເງິນມັດຈຳແລ້ວ',
  'Checked in': 'ເຂົ້າພັກແລ້ວ',
  'Status colors': 'ສີສະຖານະ',
  'Booking status colors': 'ສີສະຖານະການຈອງ',
  'Edit booking status colors': 'ປັບສີສະຖານະການຈອງ',
  'Choose a color for each booking status. Saved colors apply to calendar bars and status labels across your hotel.':
    'ເລືອກສີສຳລັບແຕ່ລະສະຖານະການຈອງ ສີທີ່ບັນທຶກຈະໃຊ້ກັບແຖບໃນປະຕິທິນ ແລະ ປ້າຍສະຖານະທົ່ວໂຮງແຮມ',
  'Make every status easy to recognize. Shared across your hotel.':
    'ເລືອກສີໃຫ້ແຍກສະຖານະໄດ້ງ່າຍ ໃຊ້ຮ່ວມກັນທົ່ວໂຮງແຮມ',
  'Reservation statuses': 'ສະຖານະການຈອງ',
  'Deposit status': 'ສະຖານະເງິນມັດຈຳ',
  'Housekeeping statuses': 'ສະຖານະແມ່ບ້ານ',
  'Choose color': 'ເລືອກສີ',
  'Hex color': 'ລະຫັດສີ Hex',
  'Invalid hex color': 'ລະຫັດສີ Hex ບໍ່ຖືກຕ້ອງ',
  'Labels stay readable, even with very light colors.': 'ຂໍ້ຄວາມອ່ານໄດ້ຊັດ ເຖິງແມ່ນເລືອກສີອ່ອນ',
  'Restore default colors': 'ຄືນຄ່າສີເດີມ',
  'Save colors': 'ບັນທຶກສີ',
  'Status colors saved': 'ບັນທຶກສີສະຖານະແລ້ວ',
  'Reload saved colors': 'ໂຫຼດສີທີ່ບັນທຶກໃໝ່',
  'Reservation actions': 'ການຈັດການການຈອງ',
  'Open reservation': 'ເປີດການຈອງ',
  'Back to reservation': 'ກັບໄປການຈອງ',
  'Reservation date': 'ວັນທີຈອງ',
  'Room assignment': 'ການຈັດຫ້ອງ',
  'Room type not recorded': 'ບໍ່ໄດ້ບັນທຶກປະເພດຫ້ອງ',
  'No rate plan recorded': 'ບໍ່ໄດ້ບັນທຶກແຜນລາຄາ',
  'Guest contact': 'ຂໍ້ມູນຕິດຕໍ່ແຂກ',
  'Profile email': 'ອີເມວໃນຂໍ້ມູນແຂກ',
  'No email provided': 'ບໍ່ໄດ້ລະບຸອີເມວ',
  'Show more': 'ສະແດງເພີ່ມເຕີມ',
  adult: 'ຜູ້ໃຫຍ່',
  adults: 'ຜູ້ໃຫຍ່',
  child: 'ເດັກ',
  children: 'ເດັກ',
  'Mark as deposited': 'ໝາຍວ່າຈ່າຍມັດຈຳແລ້ວ',
  'Remove deposited marker': 'ເອົາເຄື່ອງໝາຍມັດຈຳອອກ',
  'Deposited marker removed': 'ເອົາເຄື່ອງໝາຍມັດຈຳອອກແລ້ວ',
  'Reservation marked deposited': 'ໝາຍການຈອງວ່າຈ່າຍມັດຈຳແລ້ວ',
  'Tracks a deposit received. Record the payment with an LFB receipt to update the balance.':
    'ໝາຍວ່າໄດ້ຮັບເງິນມັດຈຳ ບັນທຶກການຮັບເງິນດ້ວຍໃບຮັບເງິນ LFB ເພື່ອປັບຍອດຄ້າງ',
  'Mark as no-show': 'ໝາຍວ່າບໍ່ມາເຂົ້າພັກ',
  'Keep on calendar': 'ເກັບໄວ້ໃນປະຕິທິນ',
  'Remove from calendar': 'ເອົາອອກຈາກປະຕິທິນ',
  'Show on calendar': 'ສະແດງໃນປະຕິທິນ',
  'Kept on calendar': 'ເກັບໄວ້ໃນປະຕິທິນແລ້ວ',
  'Removed from calendar': 'ເອົາອອກຈາກປະຕິທິນແລ້ວ',
  'Calendar display changed': 'ປ່ຽນການສະແດງໃນປະຕິທິນແລ້ວ',
  'The booking bar leaves the room calendar.': 'ແຖບການຈອງຈະຖືກເອົາອອກຈາກປະຕິທິນຫ້ອງ.',
  'The bar stays, faded, for reference. It does not hold the room.':
    'ແຖບຍັງຢູ່ ແບບຈາງໆ ເພື່ອອ້າງອີງ. ມັນບໍ່ໄດ້ຈອງຫ້ອງໄວ້.',
  'No-show reason': 'ເຫດຜົນທີ່ບໍ່ມາເຂົ້າພັກ',
  'Reservation marked no-show': 'ໝາຍການຈອງວ່າບໍ່ມາເຂົ້າພັກແລ້ວ',
  'Release the room. Keep the reservation, deposit marker and folio in history.':
    'ເປີດຫ້ອງໃຫ້ຈອງໄດ້ ຮັກສາການຈອງ ເຄື່ອງໝາຍມັດຈຳ ແລະ ບັນຊີຄ່າພັກໃນປະຫວັດ',
  'Only a confirmed booking can be marked no-show': 'ໝາຍວ່າບໍ່ມາໄດ້ສະເພາະການຈອງທີ່ຢືນຢັນແລ້ວ',
  'No-show is available on or after the arrival date':
    'ໝາຍວ່າບໍ່ມາໄດ້ໃນວັນເຂົ້າພັກ ຫຼື ຫຼັງຈາກນັ້ນ',
  'Enter a no-show reason': 'ປ້ອນເຫດຜົນທີ່ບໍ່ມາເຂົ້າພັກ',
  'Extend stay': 'ຕໍ່ການພັກ',
  'Drop on another room to review move': 'ວາງໃສ່ຫ້ອງອື່ນເພື່ອກວດສອບການຍ້າຍ',
  'Shorten stay': 'ຫຼຸດວັນພັກ',
  'Adjust dates': 'ປັບວັນພັກ',
  'Adjust departure': 'ປັບວັນອອກ',
  'Adjust stay length': 'ປັບຈຳນວນຄືນພັກ',
  'Click or drag empty dates to book': 'ຄລິກ ຫຼື ລາກວັນທີວ່າງເພື່ອຈອງ',
  'Click or drag empty dates to book. Select a stay to make changes.':
    'ຄລິກ ຫຼື ລາກວັນທີວ່າງເພື່ອຈອງ ເລືອກການພັກເພື່ອແກ້ໄຂ',
  'Drag a stay to move rooms. Drag its right edge to change departure.':
    'ລາກການພັກເພື່ອຍ້າຍຫ້ອງ ລາກຂອບຂວາເພື່ອປັບວັນອອກ',
  'Drag a stay left or right to change dates, or up or down to move rooms. Drag its right edge to change departure.':
    'ລາກການພັກໄປຊ້າຍ ຫຼື ຂວາເພື່ອປັບວັນພັກ ຫຼື ຂຶ້ນ ແລະ ລົງເພື່ອຍ້າຍຫ້ອງ ລາກຂອບຂວາເພື່ອປັບວັນອອກ',
  'Drag left or right to change dates, or onto another room to move':
    'ລາກໄປຊ້າຍ ຫຼື ຂວາເພື່ອປັບວັນພັກ ຫຼື ໄປຫ້ອງອື່ນເພື່ອຍ້າຍຫ້ອງ',
  'Drag to extend or shorten stay': 'ລາກເພື່ອຕໍ່ ຫຼື ຫຼຸດວັນພັກ',
  'Unavailable for these dates': 'ບໍ່ວ່າງໃນວັນທີ່ເລືອກ',
  'Room itinerary': 'ແຜນການພັກແຕ່ລະຫ້ອງ',
  'From room': 'ຍ້າຍມາຈາກຫ້ອງ',
  'To room': 'ຍ້າຍໄປຫ້ອງ',
  Completed: 'ສຳເລັດແລ້ວ',
  Scheduled: 'ກຳນົດໄວ້ແລ້ວ',
  'Choose the new dates. Review room availability and the updated total.':
    'ເລືອກວັນທີໃໝ່ ກວດສອບຫ້ອງວ່າງ ແລະ ຍອດລວມທີ່ປັບແລ້ວ',
  'New arrival': 'ວັນເຂົ້າໃໝ່',
  'New departure': 'ວັນອອກໃໝ່',
  'Current departure': 'ວັນອອກປັດຈຸບັນ',
  '1 night less': 'ຫຼຸດ 1 ຄືນ',
  night: 'ຄືນ',
  'Updated folio total': 'ຍອດລວມການພັກທີ່ປັບແລ້ວ',
  'Price change': 'ສ່ວນຕ່າງລາຄາ',
  'Choose a stay between 1 and 366 nights': 'ເລືອກການພັກລະຫວ່າງ 1 ຫາ 366 ຄືນ',
  'These dates are unavailable': 'ຫ້ອງບໍ່ວ່າງໃນວັນທີ່ເລືອກ',
  'Could not check availability': 'ບໍ່ສາມາດກວດສອບຫ້ອງວ່າງໄດ້',
  'Rooms available for the updated stay': 'ຫ້ອງວ່າງສຳລັບການພັກທີ່ປັບແລ້ວ',
  'Save stay dates': 'ບັນທຶກວັນພັກ',
  'Move room & dates': 'ຍ້າຍຫ້ອງ ແລະ ວັນພັກ',
  'Save room & dates': 'ບັນທຶກຫ້ອງ ແລະ ວັນພັກ',
  'Change room date': 'ປ່ຽນວັນຍ້າຍຫ້ອງ',
  'Save room change': 'ບັນທຶກການຍ້າຍຫ້ອງ',
  'Review the new room itinerary. The stay dates and total stay the same.':
    'ກວດສອບລຳດັບຫ້ອງໃໝ່ ວັນພັກ ແລະ ຍອດລວມບໍ່ປ່ຽນ',
  'Drag to change the room change date': 'ລາກເພື່ອປ່ຽນວັນຍ້າຍຫ້ອງ',
  'Room change': 'ຍ້າຍຫ້ອງ',
  'Choose a room change date within the remaining stay': 'ເລືອກວັນຍ້າຍຫ້ອງພາຍໃນການພັກທີ່ເຫຼືອ',
  'Change the room date separately from the stay dates': 'ປ່ຽນວັນຍ້າຍຫ້ອງແຍກຈາກວັນພັກ',
  'Change the room date separately from moving the reservation':
    'ປ່ຽນວັນຍ້າຍຫ້ອງແຍກຈາກການຍ້າຍການຈອງ',
  'Choose dates that include the selected room assignment': 'ເລືອກວັນພັກທີ່ລວມການພັກໃນຫ້ອງທີ່ເລືອກ',
  'Review the new room and dates. Save both changes together.':
    'ກວດສອບຫ້ອງ ແລະ ວັນພັກໃໝ່ ບັນທຶກທັງສອງຢ່າງພ້ອມກັນ',
  'Drag a stay to change its room and dates together': 'ລາກການພັກເພື່ອປັບຫ້ອງ ແລະ ວັນພັກພ້ອມກັນ',
  'Drag a stay to change its room and dates together. Drag its right edge to change departure.':
    'ລາກການພັກເພື່ອປັບຫ້ອງ ແລະ ວັນພັກພ້ອມກັນ ລາກຂອບຂວາເພື່ອປັບວັນອອກ',
  'Move on': 'ຍ້າຍໃນວັນທີ',
  'Move date': 'ວັນຍ້າຍຫ້ອງ',
  'Earlier nights stay in their original room. Later room changes are kept.':
    'ຮັກສາຄືນກ່ອນໜ້າໃນຫ້ອງເດີມ ແລະ ການຍ້າຍຫ້ອງທີ່ກຳນົດໄວ້ພາຍຫຼັງ',
  'Room move scheduled': 'ກຳນົດການຍ້າຍຫ້ອງແລ້ວ',
  'Schedule room move': 'ກຳນົດການຍ້າຍຫ້ອງ',
  'This room is reserved from the move date. Check room readiness on that day.':
    'ຈອງຫ້ອງນີ້ຕັ້ງແຕ່ວັນຍ້າຍ ກວດສອບຄວາມພ້ອມຂອງຫ້ອງໃນວັນນັ້ນ',
  'Edit stay': 'ແກ້ໄຂການພັກ',
  'Stay updated': 'ປັບການພັກແລ້ວ',
  'Before tax': 'ກ່ອນພາສີ',
  'Deluxe king': 'ຫ້ອງເດີລັກ ຕຽງໃຫຍ່',
  'Deluxe twin': 'ຫ້ອງເດີລັກ ສອງຕຽງ',
  'River suite': 'ຫ້ອງສະວີດ ວິວແມ່ນ້ຳ',
  'Review or void the linked invoice before changing this stay.':
    'ກວດສອບ ຫຼື ຍົກເລີກໃບແຈ້ງໜີ້ທີ່ເຊື່ອມກ່ອນແກ້ໄຂການພັກ',
  'Hotel PMS': 'ລະບົບຈັດການໂຮງແຮມ',
  Hospitality: 'ການໂຮງແຮມ',
  'Front desk': 'ຝ່າຍຕ້ອນຮັບ',
  Reservations: 'ການຈອງຫ້ອງ',
  'Guest groups': 'ກຸ່ມແຂກ',
  Housekeeping: 'ຝ່າຍແມ່ບ້ານ',
  'Hotel insights': 'ລາຍງານໂຮງແຮມ',
  'Connected to LFB': 'ເຊື່ອມຕໍ່ກັບ LFB',
  Laos: 'ລາວ',
  'Vientiane time': 'ເວລາວຽງຈັນ',
  'Hotel navigation': 'ເມນູໂຮງແຮມ',
  'Every stay, in the right place.': 'ທຸກການພັກ ຈັດການໄດ້ຢ່າງລົງຕົວ',
  'A calm front desk. A better guest experience.': 'ຕ້ອນຮັບຢ່າງສະດວກ ເພື່ອການພັກທີ່ປະທັບໃຈ',
  'Bring guests together. Keep every stay independent.': 'ຈັດແຂກເປັນກຸ່ມ ໂດຍຮັກສາແຕ່ລະການພັກໄວ້',
  'Room readiness, shared with your front desk.': 'ສະຖານະຫ້ອງພ້ອມໃຊ້ ເຊື່ອມຕໍ່ກັບຝ່າຍຕ້ອນຮັບ',
  'Understand your booked rooms and room revenue.': 'ເບິ່ງການຈອງຫ້ອງ ແລະ ລາຍຮັບຄ່າຫ້ອງ',
  'Find a guest, move a room, or manage a stay.': 'ຄົ້ນຫາແຂກ ຍ້າຍຫ້ອງ ແລະ ຈັດການການພັກ',
  'Add room': 'ເພີ່ມຫ້ອງ',
  'New reservation': 'ຈອງຫ້ອງໃໝ່',
  'Create reservation': 'ສ້າງການຈອງ',
  'Previous week': 'ອາທິດກ່ອນ',
  'Next week': 'ອາທິດຖັດໄປ',
  'Hotel calendar date': 'ວັນທີໃນປະຕິທິນໂຮງແຮມ',
  '14-day view': 'ເບິ່ງ 14 ມື້',
  LAK: 'ກີບ',
  'Rooms booked': 'ຫ້ອງທີ່ຈອງ',
  occupancy: 'ອັດຕາການຈອງ',
  'Expected arrivals': 'ແຂກຈະເຂົ້າພັກ',
  'Expected departures': 'ແຂກຈະອອກ',
  'Ready to welcome': 'ພ້ອມຕ້ອນຮັບ',
  'Due to check out': 'ຄົບກຳນົດອອກ',
  'Available & ready': 'ວ່າງ ແລະ ພ້ອມ',
  'For tonight': 'ສຳລັບຄືນນີ້',
  'Welcome to your hotel': 'ຍິນດີຕ້ອນຮັບສູ່ໂຮງແຮມຂອງທ່ານ',
  'Add your rooms first, then create your first reservation.': 'ເພີ່ມຫ້ອງກ່ອນ ແລ້ວສ້າງການຈອງທຳອິດ',
  'Room calendar': 'ປະຕິທິນຫ້ອງ',
  'Select a stay to manage it. Drag to preview a room move.':
    'ເລືອກການພັກເພື່ອຈັດການ ຫຼື ລາກເພື່ອກວດເບິ່ງການຍ້າຍຫ້ອງ',
  Room: 'ຫ້ອງ',
  rooms: 'ຫ້ອງ',
  'Room type': 'ປະເພດຫ້ອງ',
  'All room types': 'ທຸກປະເພດຫ້ອງ',
  'In house': 'ກຳລັງພັກ',
  Confirmed: 'ຢືນຢັນແລ້ວ',
  'Checked out': 'ອອກແລ້ວ',
  Cancelled: 'ຍົກເລີກແລ້ວ',
  'Guest group': 'ກຸ່ມແຂກ',
  'Out of service': 'ປິດໃຊ້ງານ',
  Ready: 'ພ້ອມໃຊ້',
  'Needs cleaning': 'ລໍຖ້າທຳຄວາມສະອາດ',
  'Needs repair': 'ຕ້ອງສ້ອມແປງ',
  Cleaning: 'ກຳລັງທຳຄວາມສະອາດ',
  'Room moves keep the agreed rate.': 'ການຍ້າຍຫ້ອງຮັກສາລາຄາທີ່ຕົກລົງໄວ້',
  'Everything is up to date.': 'ບໍ່ມີລາຍການທີ່ຕ້ອງຕິດຕາມ',
  guests: 'ຄົນ',
  Guests: 'ແຂກ',
  reservations: 'ການຈອງ',
  'Individual stays. Flexible groups.': 'ແຕ່ລະການພັກ ຈັດກຸ່ມໄດ້ຍືດຫຍຸ່ນ',
  'Make your first guest group': 'ສ້າງກຸ່ມແຂກທຳອິດ',
  'Select reservations below to group a family, tour or company.':
    'ເລືອກການຈອງດ້ານລຸ່ມ ເພື່ອຈັດກຸ່ມຄອບຄົວ ທົວ ຫຼື ບໍລິສັດ',
  'Search guest, group or room…': 'ຄົ້ນຫາແຂກ ກຸ່ມ ຫຼື ຫ້ອງ…',
  'All stays': 'ທຸກການພັກ',
  'Reservation status': 'ສະຖານະການຈອງ',
  'Export guests': 'ສົ່ງອອກລາຍຊື່ແຂກ',
  'Guest list exported': 'ສົ່ງອອກລາຍຊື່ແຂກແລ້ວ',
  selected: 'ເລືອກແລ້ວ',
  'Guest names, rooms and folios stay separate.': 'ຮັກສາຊື່ແຂກ ຫ້ອງ ແລະ ບັນຊີຄ່າພັກແຕ່ລະລາຍການ',
  'Group / ungroup': 'ຈັດກຸ່ມ / ແຍກກຸ່ມ',
  'Select reservations': 'ເລືອກການຈອງ',
  'Select visible active reservations': 'ເລືອກການຈອງທີ່ຍັງໃຊ້ງານໃນໜ້ານີ້',
  'Guest & reservation': 'ແຂກ ແລະ ການຈອງ',
  Stay: 'ການພັກ',
  'Folio total': 'ຍອດຄ່າພັກລວມ',
  'Room moved': 'ຍ້າຍຫ້ອງແລ້ວ',
  Individual: 'ແຕ່ລະບຸກຄົນ',
  'No stays in this view': 'ບໍ່ມີການພັກໃນຊ່ວງນີ້',
  'Change the date, clear your filters, or create a reservation.':
    'ປ່ຽນວັນທີ ລ້າງຕົວກອງ ຫຼື ສ້າງການຈອງ',
  'Clear search': 'ລ້າງການຄົ້ນຫາ',
  'Rooms become dirty automatically after a move or checkout.':
    'ຫ້ອງຈະລໍຖ້າທຳຄວາມສະອາດອັດຕະໂນມັດຫຼັງຍ້າຍຫ້ອງ ຫຼື ອອກຈາກຫ້ອງ',
  Floor: 'ຊັ້ນ',
  'No in-house guest': 'ບໍ່ມີແຂກກຳລັງພັກ',
  'Room status': 'ສະຖານະຫ້ອງ',
  'Scheduled room revenue': 'ລາຍຮັບຄ່າຫ້ອງຕາມການຈອງ',
  'Average daily rate': 'ລາຄາຫ້ອງສະເລ່ຍຕໍ່ມື້',
  'Revenue per available room': 'ລາຍຮັບຕໍ່ຫ້ອງທີ່ມີ',
  'Before tax & extras': 'ກ່ອນພາສີ ແລະ ຄ່າບໍລິການເພີ່ມ',
  'Booked occupancy': 'ອັດຕາຫ້ອງທີ່ຈອງ',
  'Confirmed and in-house stays. Cancelled stays excluded.':
    'ລວມການຈອງທີ່ຢືນຢັນ ແລະ ແຂກທີ່ກຳລັງພັກ ບໍ່ລວມການຍົກເລີກ',
  'Booking sources': 'ຊ່ອງທາງການຈອງ',
  'Every folio. Connected billing.': 'ທຸກໂຟລິໂອ ເຊື່ອມຕໍ່ການເກັບເງິນ',
  'Folios create invoices and receipts in Billing, posted to the ledger with full audit history.':
    'ໂຟລິໂອສ້າງໃບແຈ້ງໜີ້ ແລະ ໃບຮັບເງິນໃນການເກັບເງິນ, ບັນທຶກເຂົ້າບັນຊີພ້ອມປະຫວັດການກວດສອບຄົບຖ້ວນ.',
  'Open billing': 'ເປີດການເກັບເງິນ',
  'One room, one stay. Add it to a group whenever you need.':
    'ໜຶ່ງຫ້ອງ ໜຶ່ງການພັກ ສາມາດເພີ່ມເຂົ້າກຸ່ມໄດ້',
  'Guest details': 'ຂໍ້ມູນແຂກ',
  'Guest name': 'ຊື່ແຂກ',
  'Guest count': 'ຈຳນວນແຂກ',
  Nationality: 'ສັນຊາດ',
  'Room & dates': 'ຫ້ອງ ແລະ ວັນທີ',
  Arrival: 'ວັນເຂົ້າພັກ',
  Departure: 'ວັນອອກ',
  'Available room': 'ຫ້ອງວ່າງ',
  'Checking availability…': 'ກຳລັງກວດຫ້ອງວ່າງ…',
  'Only rooms available for the whole stay are shown.': 'ສະແດງສະເພາະຫ້ອງທີ່ວ່າງຕະຫຼອດການພັກ',
  'Choose a room': 'ເລືອກຫ້ອງ',
  'Rate per night (LAK)': 'ລາຄາຕໍ່ຄືນ (ກີບ)',
  'Booking source': 'ຊ່ອງທາງການຈອງ',
  Direct: 'ຈອງໂດຍກົງ',
  'Walk-in': 'ແຂກມາຈອງໜ້າໂຮງແຮມ',
  'Travel agent': 'ຕົວແທນທ່ອງທ່ຽວ',
  Corporate: 'ບໍລິສັດ',
  'Companion names & notes': 'ຊື່ຜູ້ຮ່ວມພັກ ແລະ ໝາຍເຫດ',
  'Companion names': 'ຊື່ຜູ້ຮ່ວມພັກ',
  'One name per line. The lead guest is already included.': 'ໜຶ່ງຊື່ຕໍ່ແຖວ ບໍ່ຕ້ອງໃສ່ຊື່ແຂກຫຼັກຊ້ຳ',
  'Guest notes': 'ໝາຍເຫດແຂກ',
  nights: 'ຄືນ',
  'Reservation created': 'ສ້າງການຈອງແລ້ວ',
  'Room numbers are unique within this hotel.': 'ເລກຫ້ອງຕ້ອງບໍ່ຊ້ຳກັນໃນໂຮງແຮມ',
  'Room details': 'ຂໍ້ມູນຫ້ອງ',
  'Room number': 'ເລກຫ້ອງ',
  'Guest capacity': 'ຈຳນວນແຂກທີ່ຮັບໄດ້',
  'Room added': 'ເພີ່ມຫ້ອງແລ້ວ',
  'Room status updated': 'ປັບສະຖານະຫ້ອງແລ້ວ',
  'Group action': 'ຈັດການກຸ່ມ',
  'Create a new group': 'ສ້າງກຸ່ມໃໝ່',
  'Move to an existing group': 'ຍ້າຍເຂົ້າກຸ່ມທີ່ມີ',
  'Remove from group': 'ແຍກອອກຈາກກຸ່ມ',
  'Group name': 'ຊື່ກຸ່ມ',
  'Choose a group': 'ເລືອກກຸ່ມ',
  'e.g. Mekong tour · October': 'ຕົວຢ່າງ: ທົວແມ່ຂອງ · ຕຸລາ',
  'Ungroup guests': 'ແຍກກຸ່ມແຂກ',
  'Save group': 'ບັນທຶກກຸ່ມ',
  'Guest group updated': 'ປັບກຸ່ມແຂກແລ້ວ',
  'Guests ungrouped': 'ແຍກກຸ່ມແຂກແລ້ວ',
  'Guest names, room assignments and invoices remain unchanged. You can regroup these stays later.':
    'ຮັກສາຊື່ແຂກ ຫ້ອງ ແລະ ໃບແຈ້ງໜີ້ເດີມ ສາມາດຈັດກຸ່ມໃໝ່ໄດ້ພາຍຫຼັງ',
  'Refresh reservation': 'ໂຫຼດການຈອງໃໝ່',
  'No phone provided': 'ບໍ່ໄດ້ລະບຸເບີໂທ',
  'Nationality not recorded': 'ບໍ່ໄດ້ລະບຸສັນຊາດ',
  'Move room': 'ຍ້າຍຫ້ອງ',
  'Add charge': 'ເພີ່ມຄ່າບໍລິການ',
  'Cancel reservation': 'ຍົກເລີກການຈອງ',
  'Guest folio': 'ບັນຊີຄ່າພັກແຂກ',
  'Room nights': 'ຄ່າຫ້ອງພັກ',
  'Review invoice & receive payment': 'ກວດໃບແຈ້ງໜີ້ ແລະ ຮັບເງິນ',
  'Create LFB invoice': 'ສ້າງໃບແຈ້ງໜີ້ LFB',
  'Room history': 'ປະຫວັດຫ້ອງ',
  'Check in': 'ເຂົ້າພັກ',
  'Check out': 'ອອກຈາກຫ້ອງ',
  'Guest checked in': 'ບັນທຶກເຂົ້າພັກແລ້ວ',
  'Guest checked out': 'ບັນທຶກອອກແລ້ວ',
  'Checkout is available on the departure date.': 'ສາມາດບັນທຶກອອກໃນວັນທີກຳນົດ',
  'Post the LFB invoice and settle the balance before checkout.':
    'ລົງບັນຊີໃບແຈ້ງໜີ້ LFB ແລະ ຊຳລະຍອດກ່ອນອອກ',
  'Choose a room. Review the move. Keep the same reservation.':
    'ເລືອກຫ້ອງ ກວດເບິ່ງການຍ້າຍ ແລະ ຮັກສາການຈອງເດີມ',
  'Current room': 'ຫ້ອງປັດຈຸບັນ',
  'Destination room': 'ຫ້ອງປາຍທາງ',
  Available: 'ວ່າງ',
  'Effective date': 'ວັນທີຍ້າຍ',
  'Agreed rate retained': 'ຮັກສາລາຄາທີ່ຕົກລົງ',
  'Move reason': 'ເຫດຜົນການຍ້າຍ',
  'Move notes': 'ໝາຍເຫດການຍ້າຍ',
  'Guest request': 'ແຂກຮ້ອງຂໍ',
  Maintenance: 'ສ້ອມແປງ',
  'Room upgrade': 'ປັບລະດັບຫ້ອງ',
  'Front desk correction': 'ແກ້ໄຂການຈັດຫ້ອງ',
  'Completed nights stay in room history. The previous room will need cleaning.':
    'ຄືນທີ່ພັກແລ້ວຢູ່ໃນປະຫວັດຫ້ອງ ຫ້ອງເດີມຈະລໍຖ້າທຳຄວາມສະອາດ',
  'Only the room changes. Dates, guests, group and folio stay together.':
    'ປ່ຽນຫ້ອງ ໂດຍຮັກສາວັນທີ ແຂກ ກຸ່ມ ແລະ ບັນຊີຄ່າພັກເດີມ',
  'Confirm room move': 'ຢືນຢັນການຍ້າຍຫ້ອງ',
  'Amount (LAK)': 'ຈຳນວນເງິນ (ກີບ)',
  'Charge added': 'ເພີ່ມຄ່າບໍລິການແລ້ວ',
  'Bills the guest unless you choose another customer. Post to make it final and ready for payment, or save a draft for review.':
    'ອອກບິນໃຫ້ແຂກ ເວັ້ນເສຍແຕ່ເລືອກລູກຄ້າອື່ນ ລົງບັນຊີເພື່ອໃຫ້ພ້ອມຮັບເງິນ ຫຼື ບັນທຶກຮ່າງເພື່ອກວດສອບ',
  'Create a supplementary invoice for charges or nights added after the folio was invoiced.':
    'ສ້າງໃບແຈ້ງໜີ້ເພີ່ມເຕີມສຳລັບຄ່າບໍລິການ ຫຼື ຄືນພັກທີ່ເພີ່ມຫຼັງອອກໃບແຈ້ງໜີ້',
  'Billing customer': 'ລູກຄ້າສຳລັບອອກບິນ',
  'Search name, number or phone…': 'ຄົ້ນຫາຊື່ ເລກທີ ຫຼື ເບີໂທ…',
  'Guest · own billing account': 'ແຂກ · ບັນຊີອອກບິນຂອງແຂກ',
  'Guest · new billing account for this stay': 'ແຂກ · ບັນຊີອອກບິນໃໝ່ສຳລັບການພັກນີ້',
  'Create draft invoice': 'ສ້າງຮ່າງໃບແຈ້ງໜີ້',
  'Save as draft': 'ບັນທຶກເປັນຮ່າງ',
  'Create & post invoice': 'ສ້າງ ແລະ ລົງບັນຊີໃບແຈ້ງໜີ້',
  'Draft invoice created': 'ສ້າງຮ່າງໃບແຈ້ງໜີ້ແລ້ວ',
  'LFB invoice posted': 'ລົງບັນຊີໃບແຈ້ງໜີ້ LFB ແລ້ວ',
  'The booking stays in history and the room becomes available.':
    'ຮັກສາການຈອງໃນປະຫວັດ ແລະ ເປີດຫ້ອງໃຫ້ຈອງໄດ້',
  'Cancellation reason': 'ເຫດຜົນການຍົກເລີກ',
  'Keep reservation': 'ຮັກສາການຈອງ',
  'Reservation cancelled': 'ຍົກເລີກການຈອງແລ້ວ',
  'Room is not ready': 'ຫ້ອງຍັງບໍ່ພ້ອມ',
  'Reserved for another guest': 'ມີແຂກອື່ນຈອງແລ້ວ',
  'Guest has not checked out': 'ແຂກຍັງບໍ່ໄດ້ອອກ',
  'Not enough guest capacity': 'ຈຳນວນແຂກເກີນຄວາມຈຸຫ້ອງ',
  'This record changed. Refresh before saving.': 'ຂໍ້ມູນຖືກປ່ຽນແລ້ວ ກະລຸນາໂຫຼດໃໝ່ກ່ອນບັນທຶກ',
  'Choose a different room': 'ເລືອກຫ້ອງອື່ນ',
  'Move date must be within the remaining stay': 'ວັນຍ້າຍຕ້ອງຢູ່ໃນຊ່ວງການພັກທີ່ເຫຼືອ',
  'Move upcoming and in-house guests before taking this room out of service':
    'ຍ້າຍແຂກທີ່ຈອງ ແລະ ກຳລັງພັກກ່ອນປິດຫ້ອງໃຊ້ງານ',
  'Ask your administrator for Hotel PMS access.': 'ຂໍສິດໃຊ້ລະບົບໂຮງແຮມຈາກຜູ້ດູແລ',
  'Room calendar, reservations, guest groups, housekeeping and linked LFB billing.':
    'ປະຕິທິນຫ້ອງ ການຈອງ ກຸ່ມແຂກ ແມ່ບ້ານ ແລະ ການເກັບເງິນ LFB',
  'Service & maintenance': 'ບໍລິການ ແລະ ບຳລຸງຮັກສາ',
  'Rates & restrictions': 'ລາຄາ ແລະ ຂໍ້ກຳນົດ',
  'Guest profiles': 'ຂໍ້ມູນແຂກ',
  'Daily close': 'ປິດປະຈຳວັນ',
  'Open tasks': 'ວຽກທີ່ຍັງບໍ່ສຳເລັດ',
  Overdue: 'ເກີນກຳນົດ',
  'Awaiting inspection': 'ລໍຖ້າກວດສອບ',
  'Rooms blocked today': 'ຫ້ອງທີ່ປິດມື້ນີ້',
  'Find a task, room or team member': 'ຊອກຫາວຽກ ຫ້ອງ ຫຼື ພະນັກງານ',
  'Task type': 'ປະເພດວຽກ',
  'All tasks': 'ວຽກທັງໝົດ',
  'Assigned to me': 'ວຽກທີ່ມອບໃຫ້ຂ້ອຍ',
  'Active tasks': 'ວຽກທີ່ກຳລັງດຳເນີນ',
  'Completed tasks': 'ວຽກທີ່ສຳເລັດ',
  'Block a room': 'ປິດຫ້ອງຊົ່ວຄາວ',
  'New task': 'ວຽກໃໝ່',
  'To do': 'ຕ້ອງດຳເນີນ',
  'In progress': 'ກຳລັງດຳເນີນ',
  Normal: 'ປົກກະຕິ',
  High: 'ສູງ',
  Urgent: 'ດ່ວນ',
  Unassigned: 'ຍັງບໍ່ມອບໝາຍ',
  'Scheduled room blocks': 'ກຳນົດປິດຫ້ອງ',
  'No scheduled room blocks': 'ບໍ່ມີກຳນົດປິດຫ້ອງ',
  Ended: 'ສິ້ນສຸດແລ້ວ',
  'Release block': 'ເປີດຫ້ອງຄືນ',
  'Review task': 'ກວດສອບວຽກ',
  'Task status': 'ສະຖານະວຽກ',
  'Task details': 'ລາຍລະອຽດວຽກ',
  'Task title': 'ຫົວຂໍ້ວຽກ',
  'No room': 'ບໍ່ລະບຸຫ້ອງ',
  Priority: 'ຄວາມສຳຄັນ',
  'Assigned to': 'ມອບໝາຍໃຫ້',
  'Completion notes': 'ໝາຍເຫດການສຳເລັດ',
  Instructions: 'ຄຳແນະນຳ',
  'Save task': 'ບັນທຶກວຽກ',
  'Task saved': 'ບັນທຶກວຽກແລ້ວ',
  'Save room block': 'ບັນທຶກການປິດຫ້ອງ',
  'Room block saved': 'ບັນທຶກການປິດຫ້ອງແລ້ວ',
  'Release reason': 'ເຫດຜົນທີ່ເປີດຄືນ',
  'Room block released': 'ເປີດຫ້ອງຄືນແລ້ວ',
  'Rate calendar date': 'ວັນທີໃນປະຕິທິນລາຄາ',
  'LAK per night': 'ກີບຕໍ່ຄືນ',
  '7-day rate view': 'ລາຄາ 7 ວັນ',
  'New rate plan': 'ແຜນລາຄາໃໝ່',
  'Rate plan': 'ແຜນລາຄາ',
  Inactive: 'ບໍ່ໃຊ້ງານ',
  'Edit plan': 'ແກ້ໄຂແຜນ',
  'Edit rate': 'ແກ້ໄຂລາຄາ',
  'Stop sell': 'ຢຸດຂາຍ',
  'Date override': 'ລາຄາສະເພາະວັນ',
  'Base rate': 'ລາຄາພື້ນຖານ',
  'Closed to arrival': 'ບໍ່ຮັບເຂົ້າພັກ',
  'Closed to departure': 'ບໍ່ຮັບອອກ',
  Min: 'ຕ່ຳສຸດ',
  'Edit rate plan': 'ແກ້ໄຂແຜນລາຄາ',
  'Plan details': 'ລາຍລະອຽດແຜນ',
  'Plan name': 'ຊື່ແຜນ',
  'Base rate (LAK)': 'ລາຄາພື້ນຖານ (ກີບ)',
  'Minimum nights': 'ຈຳນວນຄືນຕ່ຳສຸດ',
  'Maximum nights': 'ຈຳນວນຄືນສູງສຸດ',
  'Available for new bookings': 'ເປີດສຳລັບການຈອງໃໝ່',
  'Save rate plan': 'ບັນທຶກແຜນລາຄາ',
  'Rate plan saved': 'ບັນທຶກແຜນລາຄາແລ້ວ',
  'Prices & restrictions': 'ລາຄາ ແລະ ຂໍ້ກຳນົດ',
  'Date range': 'ຊ່ວງວັນທີ',
  'From date': 'ຈາກວັນທີ',
  'Through date': 'ເຖິງວັນທີ',
  'Nightly pricing': 'ລາຄາຕໍ່ຄືນ',
  'Apply to dates': 'ນຳໃຊ້ກັບວັນທີ',
  'Rate rules saved': 'ບັນທຶກຂໍ້ກຳນົດລາຄາແລ້ວ',
  'New guest profile': 'ຂໍ້ມູນແຂກໃໝ່',
  'Guest profile': 'ຂໍ້ມູນແຂກ',
  'Guest preferences': 'ຄວາມຕ້ອງການຂອງແຂກ',
  'Staff notes': 'ໝາຍເຫດພະນັກງານ',
  'Linked reservations': 'ການຈອງທີ່ເຊື່ອມໂຍງ',
  'No linked reservations': 'ບໍ່ມີການຈອງທີ່ເຊື່ອມໂຍງ',
  'Edit profile': 'ແກ້ໄຂຂໍ້ມູນ',
  'Edit guest profile': 'ແກ້ໄຂຂໍ້ມູນແຂກ',
  'VIP guest': 'ແຂກ VIP',
  'Guest has given marketing consent': 'ແຂກໄດ້ຍິນຍອມຮັບຂໍ້ມູນການຕະຫຼາດ',
  'Save guest profile': 'ບັນທຶກຂໍ້ມູນແຂກ',
  'Guest profile saved': 'ບັນທຶກຂໍ້ມູນແຂກແລ້ວ',
  'No preferences recorded': 'ຍັງບໍ່ມີຄວາມຕ້ອງການທີ່ບັນທຶກ',
  'First visit': 'ການພັກຄັ້ງທຳອິດ',
  stays: 'ຄັ້ງທີ່ພັກ',
  'Stay history': 'ປະຫວັດການພັກ',
  Preferences: 'ການຕັ້ງຄ່າ',
  Contact: 'ຕິດຕໍ່',
  'No guest profiles found': 'ບໍ່ພົບຂໍ້ມູນແຂກ',
  'Use saved guest profile': 'ໃຊ້ຂໍ້ມູນແຂກທີ່ບັນທຶກ',
  'New guest / no profile': 'ແຂກໃໝ່ / ບໍ່ໃຊ້ຂໍ້ມູນເກົ່າ',
  'Agreed rate / manual': 'ລາຄາທີ່ຕົກລົງ / ປ້ອນເອງ',
  'Checking rate and restrictions…': 'ກຳລັງກວດສອບລາຄາ ແລະ ຂໍ້ກຳນົດ…',
  'Day to close': 'ວັນທີຈະປິດ',
  'Completed days': 'ວັນທີ່ສິ້ນສຸດແລ້ວ',
  'Day closed': 'ປິດວັນແລ້ວ',
  'Resolve before closing': 'ແກ້ໄຂກ່ອນປິດວັນ',
  'Ready to close': 'ພ້ອມປິດວັນ',
  'Occupied room nights': 'ຈຳນວນຫ້ອງທີ່ພັກຕໍ່ຄືນ',
  'Review & close day': 'ກວດສອບ ແລະ ປິດວັນ',
  'Closed days': 'ວັນທີ່ປິດແລ້ວ',
  'Close this day': 'ປິດວັນນີ້',
  'Shift notes': 'ໝາຍເຫດປະຈຳຜຽນ',
  'room nights': 'ຫ້ອງຕໍ່ຄືນ',
  'Close day': 'ປິດວັນ',
  'Correct charge': 'ແກ້ໄຂຄ່າບໍລິການ',
  'Edit charge': 'ແກ້ໄຂຄ່າບໍລິການ',
  'Remove charge': 'ເອົາຄ່າບໍລິການອອກ',
  'Correction reason': 'ເຫດຜົນການແກ້ໄຂ',
  'Save correction': 'ບັນທຶກການແກ້ໄຂ',
  'Charge corrected': 'ແກ້ໄຂຄ່າບໍລິການແລ້ວ',
  'Charge removed': 'ເອົາຄ່າບໍລິການອອກແລ້ວ',
  'Room blocked': 'ຫ້ອງຖືກປິດ',
  Blocked: 'ປິດຊົ່ວຄາວ',
  'Cleaning goes to inspection. A manager releases the room as ready.':
    'ຫຼັງອະນາໄມ ຕ້ອງກວດສອບ ຜູ້ຈັດການຈະຢືນຢັນວ່າຫ້ອງພ້ອມ',
  'Existing reservations keep their saved prices. New bookings use the latest plan and restrictions.':
    'ການຈອງເກົ່າຮັກສາລາຄາທີ່ບັນທຶກ ການຈອງໃໝ່ໃຊ້ແຜນລາຄາ ແລະ ຂໍ້ກຳນົດຫຼ້າສຸດ',
  'Daily close saves an immutable operational snapshot. Financial revenue and tax are posted through LFB invoices.':
    'ການປິດວັນບັນທຶກລາຍງານທີ່ບໍ່ສາມາດປ່ຽນໄດ້ ລາຍຮັບ ແລະ ພາສີບັນທຶກຜ່ານໃບແຈ້ງໜີ້ LFB',
  'Find a guest by name, phone or email': 'ຊອກຫາແຂກດ້ວຍຊື່ ເບີໂທ ຫຼື ອີເມວ',
  'Give every request a clear owner and next step.':
    'ມອບໝາຍຜູ້ຮັບຜິດຊອບ ແລະ ຂັ້ນຕອນຕໍ່ໄປໃຫ້ທຸກຄຳຮ້ອງຂໍ',
  'Set the right price. Protect the right dates.': 'ກຳນົດລາຄາ ແລະ ຂໍ້ກຳນົດການຈອງໃຫ້ເໝາະສົມ',
  'Recognize returning guests. Remember what matters.': 'ຮູ້ຈັກແຂກທີ່ກັບມາພັກ ແລະ ຈື່ຄວາມຕ້ອງການ',
  'Resolve the day. Leave a clear handover.': 'ກວດສອບວຽກປະຈຳວັນ ແລະ ສົ່ງມອບຜຽນໃຫ້ຊັດເຈນ',
  stay: 'ຄັ້ງທີ່ພັກ',
  'No completed stays': 'ຍັງບໍ່ມີການພັກທີ່ສຳເລັດ',
  'Cleaned rooms appear here for manager inspection.':
    'ຫ້ອງທີ່ອະນາໄມແລ້ວຈະປາກົດທີ່ນີ້ເພື່ອໃຫ້ຜູ້ຈັດການກວດສອບ',
  'No tasks in this column': 'ບໍ່ມີວຽກໃນຖັນນີ້',
  'Unavailable for booking during these dates. End date is exclusive.':
    'ຫ້ອງບໍ່ຮັບການຈອງໃນຊ່ວງນີ້ ວັນສິ້ນສຸດເປີດໃຫ້ຈອງໄດ້',
  'Due date': 'ວັນກຳນົດ',
  'Move affected reservations before blocking inventory.': 'ຍ້າຍການຈອງທີ່ກ່ຽວຂ້ອງກ່ອນປິດຫ້ອງ',
  'The dates become available again. Check room readiness before the next arrival.':
    'ວັນທີຈະເປີດໃຫ້ຈອງຄືນ ກວດສອບຄວາມພ້ອມຂອງຫ້ອງກ່ອນແຂກເຂົ້າພັກ',
  'Select a date to update prices and restrictions across a date range.':
    'ເລືອກວັນທີເພື່ອປັບລາຄາ ແລະ ຂໍ້ກຳນົດສຳລັບຊ່ວງວັນທີ',
  'One rate plan for one room type. Date overrides add seasonal pricing.':
    'ແຕ່ລະແຜນລາຄາໃຊ້ກັບໜຶ່ງປະເພດຫ້ອງ ລາຄາສະເພາະວັນໃຊ້ກຳນົດລາຄາຕາມລະດູການ',
  'Restore base prices and restrictions for these dates':
    'ຄືນຄ່າລາຄາພື້ນຖານ ແລະ ຂໍ້ກຳນົດໃນວັນທີເຫຼົ່ານີ້',
  'Stay limits apply on arrival. Stop sell applies to every booked night.':
    'ຂໍ້ກຳນົດຈຳນວນຄືນໃຊ້ໃນວັນເຂົ້າພັກ ການຢຸດຂາຍໃຊ້ກັບທຸກຄືນທີ່ຈອງ',
  'Preferences that travel with your guests': 'ຈື່ຄວາມຕ້ອງການຂອງແຂກທຸກຄັ້ງທີ່ເຂົ້າພັກ',
  'Showing 200 profiles. Refine your search to find a guest.':
    'ສະແດງ 200 ລາຍການ ປັບຄຳຄົ້ນຫາເພື່ອຊອກແຂກ',
  'Guest details, preferences and linked reservations':
    'ລາຍລະອຽດແຂກ ຄວາມຕ້ອງການ ແລະ ການຈອງທີ່ເຊື່ອມໂຍງ',
  'Marketing consent recorded': 'ບັນທຶກຄວາມຍິນຍອມຮັບການຕະຫຼາດແລ້ວ',
  'Marketing consent not recorded': 'ຍັງບໍ່ມີຄວາມຍິນຍອມຮັບການຕະຫຼາດ',
  'Most recent 50 reservations. Profiles are linked explicitly; names alone never merge guests.':
    'ສະແດງການຈອງຫຼ້າສຸດ 50 ລາຍການ ການເຊື່ອມໂຍງຕ້ອງເລືອກຢ່າງຊັດເຈນ ຊື່ຄືກັນບໍ່ໄດ້ຮວມຂໍ້ມູນອັດຕະໂນມັດ',
  'Remember preferences without changing past reservations.':
    'ບັນທຶກຄວາມຕ້ອງການໂດຍຮັກສາຂໍ້ມູນການຈອງທີ່ຜ່ານມາ',
  'Room, pillow, accessibility or dietary preferences shared by the guest.':
    'ຄວາມຕ້ອງການທີ່ແຂກແຈ້ງ ເຊັ່ນ ຫ້ອງ ໝອນ ການເຂົ້າເຖິງ ຫຼື ອາຫານ',
  'Review the outstanding arrivals and departures below.':
    'ກວດສອບລາຍການເຂົ້າ ແລະ ອອກທີ່ຍັງຄ້າງຢູ່ດ້ານລຸ່ມ',
  'All arrivals and departures have been resolved for this day.':
    'ລາຍການເຂົ້າ ແລະ ອອກຂອງວັນນີ້ຖືກແກ້ໄຂແລ້ວ',
  'Your completed daily reports will appear here.': 'ລາຍງານປະຈຳວັນທີ່ປິດແລ້ວຈະປາກົດທີ່ນີ້',
  'The saved report cannot be overwritten.': 'ລາຍງານທີ່ບັນທຶກແລ້ວບໍ່ສາມາດຂຽນທັບໄດ້',
  'Choose a returning guest or enter new guest details below.':
    'ເລືອກແຂກທີ່ເຄີຍພັກ ຫຼື ປ້ອນຂໍ້ມູນແຂກໃໝ່ດ້ານລຸ່ມ',
  'This charge leaves the folio. The original amount and your reason stay in activity history.':
    'ຄ່າບໍລິການນີ້ຈະຖືກເອົາອອກຈາກບັນຊີ ຈຳນວນເດີມ ແລະ ເຫດຜົນຍັງຢູ່ໃນປະຫວັດ',
  'Rate calendar': 'ປະຕິທິນລາຄາ',
  'Outstanding arrivals reviewed': 'ກວດສອບລາຍການເຂົ້າພັກທີ່ຍັງຄ້າງ',
  'Due departures resolved': 'ແກ້ໄຂລາຍການອອກທີ່ຄົບກຳນົດ',
  'Room revenue snapshot prepared': 'ກຽມລາຍງານລາຍຮັບຄ່າຫ້ອງ',
  'Check in late or mark no-show': 'ບັນທຶກເຂົ້າພັກຊ້າ ຫຼື ໝາຍວ່າບໍ່ມາ',
  'Check out or extend this stay': 'ບັນທຶກການອອກ ຫຼື ຕໍ່ການພັກ',
  Arrivals: 'ເຂົ້າພັກ',
  Departures: 'ອອກ',
  'Extend overstays at daily close': 'ຕໍ່ການພັກເກີນກຳນົດເມື່ອປິດວັນ',
  'Daily close can extend each guest who has not checked out by one night at the booked rate. A guest booked into that room keeps the room and is listed so staff can move them.':
    'ການປິດວັນສາມາດຕໍ່ການພັກໃຫ້ແຂກທີ່ຍັງບໍ່ໄດ້ເຊັກເອົາອີກ 1 ຄືນ ຕາມລາຄາທີ່ຈອງໄວ້. ແຂກທີ່ຈອງຫ້ອງນັ້ນໄວ້ຍັງຄົງໄດ້ຫ້ອງເດີມ ແລະ ຖືກສະແດງໃນລາຍການເພື່ອໃຫ້ພະນັກງານຍ້າຍຫ້ອງ.',
  'Extend all overstays by 1 night': 'ຕໍ່ການພັກເກີນກຳນົດທັງໝົດອີກ 1 ຄືນ',
  'Each extra night is charged at the booked rate and recorded as an automatic overstay extension.':
    'ແຕ່ລະຄືນທີ່ເພີ່ມຈະຄິດລາຄາຕາມອັດຕາທີ່ຈອງ ແລະ ບັນທຶກເປັນການຕໍ່ການພັກເກີນກຳນົດອັດຕະໂນມັດ.',
  'Overstays extended': 'ຕໍ່ການພັກເກີນກຳນົດແລ້ວ',
  'Arrival needs a new room': 'ແຂກທີ່ຈະເຂົ້າພັກຕ້ອງການຫ້ອງໃໝ່',
  'Still occupied by': 'ຍັງມີແຂກພັກຢູ່',
  'Automatic overstay extension': 'ຕໍ່ການພັກເກີນກຳນົດອັດຕະໂນມັດ',
  'More than one night is unbooked. Extend this stay manually.':
    'ມີຫຼາຍກວ່າໜຶ່ງຄືນທີ່ບໍ່ໄດ້ຈອງ. ກະລຸນາຕໍ່ການພັກດ້ວຍຕົນເອງ.',
  'Room blocked for service or maintenance': 'ຫ້ອງຖືກກັນໄວ້ເພື່ອບໍລິການ ຫຼື ສ້ອມແປງ',
  'Turn on automatic overstay extension in Hotel settings':
    'ເປີດການຕໍ່ການພັກເກີນກຳນົດອັດຕະໂນມັດໃນການຕັ້ງຄ່າໂຮງແຮມ',
  'This day is already closed': 'ວັນນີ້ປິດແລ້ວ',
  'Late check-in': 'ເຂົ້າພັກຊ້າ',
  'Late check-in recorded': 'ບັນທຶກການເຂົ້າພັກຊ້າແລ້ວ',
  'Late check-in reason': 'ເຫດຜົນທີ່ບັນທຶກເຂົ້າພັກຊ້າ',
  'Confirm late check-in': 'ຢືນຢັນການເຂົ້າພັກຊ້າ',
  'Record a check-in that was missed on the arrival date. The guest is In-House from the booked arrival; nights and charges are unchanged.':
    'ບັນທຶກການເຂົ້າພັກທີ່ລືມບັນທຶກໃນວັນເຂົ້າພັກ ແຂກຈະເປັນກຳລັງພັກນັບແຕ່ວັນເຂົ້າພັກທີ່ຈອງໄວ້ ຈຳນວນຄືນ ແລະ ຄ່າພັກຄົງເດີມ',
  'Requires a manager with hotel approval permission. Unavailable after a daily close has reported the arrival date.':
    'ຕ້ອງໃຫ້ຜູ້ຈັດການທີ່ມີສິດອະນຸມັດໂຮງແຮມ ແລະ ໃຊ້ບໍ່ໄດ້ຫຼັງຈາກປິດວັນທີ່ລາຍງານວັນເຂົ້າພັກແລ້ວ',
  'Requires a manager with hotel approval permission.': 'ຕ້ອງໃຫ້ຜູ້ຈັດການທີ່ມີສິດອະນຸມັດໂຮງແຮມ',
  'Missed check-out': 'ລືມບັນທຶກອອກ',
  'Missed check-out recorded': 'ບັນທຶກການອອກທີ່ລືມແລ້ວ',
  'Missed check-out reason': 'ເຫດຜົນທີ່ລືມບັນທຶກອອກ',
  'Confirm missed check-out': 'ຢືນຢັນການອອກທີ່ລືມບັນທຶກ',
  'Record that the guest left on the booked departure date but checkout was not entered. The room is marked dirty for inspection.':
    'ບັນທຶກວ່າແຂກອອກໃນວັນອອກທີ່ຈອງໄວ້ ແຕ່ບໍ່ໄດ້ບັນທຶກການອອກ ຫ້ອງຈະຖືກໝາຍວ່າລໍຖ້າທຳຄວາມສະອາດເພື່ອກວດສອບ',
  'If the guest stayed longer, extend the stay and use regular checkout instead. Requires a manager with hotel approval permission.':
    'ຖ້າແຂກພັກດົນກວ່ານັ້ນ ໃຫ້ຕໍ່ການພັກ ແລ້ວໃຊ້ການອອກປົກກະຕິ ຕ້ອງໃຫ້ຜູ້ຈັດການທີ່ມີສິດອະນຸມັດໂຮງແຮມ',
  'If the guest left on the booked date and checkout was missed, record a missed check-out.':
    'ຖ້າແຂກອອກໃນວັນທີ່ຈອງໄວ້ ແຕ່ລືມບັນທຶກການອອກ ໃຫ້ບັນທຶກການອອກທີ່ລືມ',
  'Undo check-out': 'ຍົກເລີກການອອກ',
  'Undo check-out reason': 'ເຫດຜົນທີ່ຍົກເລີກການອອກ',
  'Check-out undone': 'ຍົກເລີກການອອກແລ້ວ',
  'Return this stay to In-House when checkout was recorded by mistake. The folio, invoice and room status are unchanged.':
    'ຄືນການພັກນີ້ເປັນກຳລັງພັກ ເມື່ອບັນທຶກການອອກຜິດພາດ ບັນຊີຄ່າພັກ ໃບແຈ້ງໜີ້ ແລະ ສະຖານະຫ້ອງຄົງເດີມ',
  'Available on the day the checkout was recorded, while the room has not been given to another guest.':
    'ໃຊ້ໄດ້ໃນວັນທີ່ບັນທຶກການອອກ ແລະ ຫ້ອງຍັງບໍ່ໄດ້ມອບໃຫ້ແຂກຄົນອື່ນ',
  'Available on the arrival date, or the day a late check-in was recorded, before an occupied room move. Room readiness is unchanged.':
    'ໃຊ້ໄດ້ໃນວັນເຂົ້າພັກ ຫຼື ວັນທີ່ບັນທຶກເຂົ້າພັກຊ້າ ກ່ອນຍ້າຍຫ້ອງທີ່ເຂົ້າພັກແລ້ວ ສະຖານະຄວາມພ້ອມຂອງຫ້ອງຄົງເດີມ',
  'Booked arrival': 'ວັນເຂົ້າພັກທີ່ຈອງໄວ້',
  'Actual arrival': 'ວັນເຂົ້າພັກຕົວຈິງ',
  'Recorded on': 'ບັນທຶກເມື່ອ',
  'Days late': 'ຊ້າ (ມື້)',
  'Reversed checkout': 'ການອອກທີ່ຖືກຍົກເລີກ',
  'Use regular check-in on the arrival date': 'ໃຊ້ການເຂົ້າພັກປົກກະຕິໃນວັນເຂົ້າພັກ',
  'Use regular checkout on the departure date': 'ໃຊ້ການອອກປົກກະຕິໃນວັນອອກ',
  'A daily close already reported this arrival. Late check-in is unavailable.':
    'ການປິດວັນໄດ້ລາຍງານການເຂົ້າພັກນີ້ແລ້ວ ບໍ່ສາມາດບັນທຶກເຂົ້າພັກຊ້າໄດ້',
  'A daily close already reported this departure. Use regular checkout.':
    'ການປິດວັນໄດ້ລາຍງານການອອກນີ້ແລ້ວ ໃຫ້ໃຊ້ການອອກປົກກະຕິ',
  'Only a checked-out reservation can return to in-house':
    'ສະເພາະການຈອງທີ່ອອກແລ້ວເທົ່ານັ້ນທີ່ຄືນເປັນກຳລັງພັກໄດ້',
  'Undo check-out is available on the day the checkout was recorded':
    'ຍົກເລີກການອອກໄດ້ສະເພາະວັນທີ່ບັນທຶກການອອກ',
  'Another checked-in guest occupies this room. Resolve that stay first.':
    'ມີແຂກຄົນອື່ນກຳລັງພັກຢູ່ຫ້ອງນີ້ ກະລຸນາແກ້ໄຂການພັກນັ້ນກ່ອນ',

  Cards: 'ບັດ',
  Table: 'ຕາຕະລາງ',
  'Room layout': 'ຮູບແບບການສະແດງຫ້ອງ',
  'Housekeeping view': 'ມຸມມອງວຽກອະນາໄມ',
  'Cleaning tasks': 'ວຽກອະນາໄມຫ້ອງ',
  'Start with rooms that need cleaning. Changes are shared with the front desk.':
    'ເລີ່ມຈາກຫ້ອງທີ່ຕ້ອງອະນາໄມ. ການປ່ຽນແປງຈະສະແດງໃຫ້ຝ່າຍຕ້ອນຮັບເຫັນ.',
  'Find a room, type or floor': 'ຄົ້ນຫາຫ້ອງ, ປະເພດ ຫຼື ຊັ້ນ',
  'Needs cleaning first': 'ຫ້ອງທີ່ຕ້ອງອະນາໄມກ່ອນ',
  'Open room': 'ເປີດເບິ່ງຫ້ອງ',
  'Start cleaning': 'ເລີ່ມອະນາໄມ',
  'Use cleaning tasks to assign staff and request inspection.':
    'ໃຊ້ວຽກອະນາໄມເພື່ອມອບໝາຍພະນັກງານ ແລະ ຂໍກວດຫ້ອງ.',
  'Assign an owner, track cleaning and release rooms after inspection.':
    'ມອບໝາຍຜູ້ຮັບຜິດຊອບ, ຕິດຕາມການອະນາໄມ ແລະ ປ່ອຍຫ້ອງຫຼັງກວດສອບ.',
};
